import { motion, AnimatePresence } from "framer-motion";
import { QUANTITY_UNITS } from "@/constants";
import { isLiquidIngredient } from "@/utils/ingredients";

export const EditQuantityModal = ({
  editingIngredient,
  setEditingIngredient,
  editQuantity,
  setEditQuantity,
  editUnit,
  setEditUnit,
  saveEditedQuantity,
}) => {
  const isLiquid = editingIngredient ? isLiquidIngredient(editingIngredient.name) : false;
  const filteredUnits = QUANTITY_UNITS.filter(u =>
    !u.type || u.type === "both" || (isLiquid ? u.type === "liquid" : u.type === "solid")
  );

  return (
    <AnimatePresence>
      {editingIngredient && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[160] p-4"
          onClick={() => setEditingIngredient(null)}
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
            className="bg-[#FEFAE0] rounded-3xl max-w-sm w-full overflow-hidden shadow-2xl"
            data-testid="edit-quantity-modal"
          >
            <div className="bg-gradient-to-r from-[#2A9D8F] to-[#3AB795] p-5">
              <h2 className="text-xl font-bold text-white capitalize" style={{ fontFamily: "'Fraunces', serif" }}>
                {editingIngredient.name}
              </h2>
              <p className="text-white/80 text-sm">Edit quantity</p>
            </div>

            <div className="p-5">
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-[#264653] mb-2">Quantity</label>
                  <input
                    type="text"
                    value={editQuantity}
                    onChange={(e) => setEditQuantity(e.target.value)}
                    placeholder="e.g., 3, 1/2, ~500g"
                    className="w-full px-4 py-3 rounded-xl bg-white border-2 border-[#264653]/10 text-[#264653] placeholder:text-[#264653]/40 focus:border-[#2A9D8F] focus:outline-none transition-colors"
                    data-testid="edit-quantity-input"
                    autoFocus
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-[#264653] mb-2">Unit (optional)</label>
                  <select
                    value={editUnit}
                    onChange={(e) => setEditUnit(e.target.value)}
                    className="w-full px-4 py-3 rounded-xl bg-white border-2 border-[#264653]/10 text-[#264653] focus:border-[#2A9D8F] focus:outline-none transition-colors"
                    data-testid="edit-unit-select"
                  >
                    {filteredUnits.map(unit => (
                      <option key={unit.value} value={unit.value}>{unit.label}</option>
                    ))}
                  </select>
                </div>

                <div className="bg-[#2A9D8F]/10 rounded-xl p-3">
                  <p className="text-xs text-[#264653]/60 mb-1">Preview:</p>
                  <p className="font-medium text-[#264653]">
                    {editQuantity ? (
                      <>
                        <span className="text-[#2A9D8F] font-bold">{editQuantity}</span>
                        {editUnit && editUnit !== 'pieces' && <span className="text-[#2A9D8F] font-bold"> {editUnit}</span>}
                        <span className="capitalize"> {editingIngredient.name}</span>
                      </>
                    ) : (
                      <span className="capitalize text-[#264653]/50">{editingIngredient.name} (no quantity)</span>
                    )}
                  </p>
                </div>
              </div>
            </div>

            <div className="p-5 border-t border-[#264653]/10 bg-white/50 flex gap-3">
              <button
                onClick={() => setEditingIngredient(null)}
                className="flex-1 px-4 py-3 rounded-full border-2 border-[#264653]/20 text-[#264653] font-bold hover:bg-[#264653]/5 transition-all"
                data-testid="edit-qty-cancel-btn"
              >
                Cancel
              </button>
              <button
                onClick={saveEditedQuantity}
                className="flex-1 px-4 py-3 rounded-full bg-[#2A9D8F] text-white font-bold hover:opacity-90 transition-all"
                style={{ boxShadow: "3px 3px 0px 0px rgba(38, 70, 83, 0.8)" }}
                data-testid="edit-qty-save-btn"
              >
                Save
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
